export default "__VITE_ASSET__D$0c78eb__"